module.exports = __webpack_public_path__ + "img/qr-app-store.dc7a6e68.png";